ACC.pdp = {
  displayNone: 'ph-d-none',
  productMain: '.ph-pdp_product_description_main',
  productCode: '',
  closingPnDiv: '</p></div>',
  closingTwoDivs: '</div></div>',
  maxAgeValue: 'max-age=6000',

  pdpFeature: function() {
    $(document).on('click', '.ph-productfeature_button_showall', function() {
      $('.ph-productfeature_section_showmore').removeClass(ACC.pdp.displayNone);
      $(this).addClass(ACC.pdp.displayNone);
      $('.ph-productfeature_button_showless').removeClass(ACC.pdp.displayNone);
    });

    $(document).on('click', '.ph-productfeature_button_showless', function() {
      $('.ph-productfeature_section_showmore').addClass(ACC.pdp.displayNone);
      $(this).addClass(ACC.pdp.displayNone);
      $('.ph-productfeature_button_showall').removeClass(ACC.pdp.displayNone);
    });
  },
  pdpAjaxCall: function(productCode, variantStatus, suggestedStatus) {
    var toenableVariant = $('.ph-pdp-varient').html(),
        prodRefType = $('.ph-product-Refer').html(),
        maxLimit = $('.ph-product-maxProduct').html();

    $.ajax({
      url: ACC.config.contextPath + '/lazyload/getProductDetails.json',
      type: 'POST',
      data: {
        productCode: productCode,
        prodRef: suggestedStatus,
        prodRefType: prodRefType,
        maxLimit: maxLimit
      },
      async: false,
      cache: true,
      headers: {
        'Cache-Control': ACC.pdp.maxAgeValue
      },
      dataType: 'json',
      success: function(result) {
        if (result.productData) {
          ACC.pdp.pdpOverview(result.productData);
          ACC.pdp.pdpSpecs(result.productData);
          ACC.pdp.changeShareFeature(result.productData);

          if (variantStatus === 'false') {
            ACC.pdp.pdpPrxCtn(result.productData);
          }
        }

        if (result.relatedProductsData) {
          ACC.pdp.pdpSuggestedProductsMain(result.relatedProductsData);
        }

        if (result.componentProducts) {
          ACC.pdp.pdpSuggestedProductsMain(result.componentProducts);
        }

        if (variantStatus === 'true') {
          if (result.productData.clusterCode && toenableVariant === 'true') {
            ACC.pdp.pdpVariantCall(result.productData);
          }
        }
      }
    });
  },

  pdpFeatureAjaxCall: function(productCode) {
    $.ajax({
      url: ACC.config.contextPath + '/lazyload/getPRXFeatureForProduct.json',
      type: 'GET',
      data: {
        productCode: productCode
      },
      async: false,
      cache: true,
      headers: {
        'Cache-Control': ACC.pdp.maxAgeValue
      },
      dataType: 'json',
      success: function(result) {
        if (result.productData && result.productData.keyBenefitAreas) {
          ACC.pdp.pdpProductFeature(result.productData.keyBenefitAreas);
        }
      }
    });
  },

  pdpResourceAjaxCall: function(productCode) {
    var assetTypes = ACC.pdp.pdpNullCheck($('.prodAssetType').html());

    $.ajax({
      url: ACC.config.contextPath + '/lazyload/getPRXResourcesForProduct.json',
      type: 'POST',
      data: {
        productCode: productCode,
        assetTypes: assetTypes
      },
      async: false,
      cache: true,
      headers: {
        'Cache-Control': ACC.pdp.maxAgeValue
      },
      dataType: 'json',
      success: function(result) {
        if (result.assetsForDocument && result.assetsForDocument.assets) {
          ACC.pdp.pdpResources(result.assetsForDocument.assets);
        }

        if (result.assetsForCaseStudies && result.assetsForCaseStudies.assets) {
          ACC.pdp.pdpCaseStudiesNew(result.assetsForCaseStudies.assets);
        }
      }
    });
  },

  pdpOverview: function(productDataMap) {
    var $productSummary = $(ACC.pdp.productMain).find('.ph-pdp_product_descriptor'),
        $productDescription = $(ACC.pdp.productMain).find('.ph-pdp_product_description'),
        $productDisclaimer = $('.ph-pdp_disclaimer__main .ph-disclaimertext'),
        $productName = $(ACC.pdp.productMain).find('.ph-variant_productname');

    if (productDataMap.prxProductName) {
      $productName.html(productDataMap.prxProductName);
    } else if (productDataMap.name) {
      $productName.html(productDataMap.name);
    }

    if (productDataMap.summary) {
      $productSummary.html(productDataMap.summary);
    }

    if (productDataMap.marketingTextHeader) {
      $productDescription.html(productDataMap.marketingTextHeader);
    }

    if (productDataMap.disclaimers) {
      if (productDataMap.disclaimers.disclaimers) {
        var disclaimerArray = productDataMap.disclaimers.disclaimers;

        $.each(disclaimerArray, function(disclaimerIndex, individualDisclaimer) {
          $productDisclaimer.append(individualDisclaimer.disclaimerText);
        });
      }
    }

    if (productDataMap.versions) {
      var versionArray = productDataMap.versions,
          versionStructure = '';

      $.each(versionArray, function(versionIndex, individualVersion) {
        versionStructure = versionStructure + '<div class="ph-pdp_version--item"><span class="ph-icon-checkmark ph-pdp_checkmarkstyle"></span>' +
                             '<span class="ph-pdp_versiontext">' + individualVersion + '</span></div>';
        $(ACC.pdp.productMain).find('.ph-pdp_version__main').html(versionStructure);
      });
    }
  },

  specFeatures: function(specificFeature) {
    var symbolVal = '';

    if (specificFeature.featureUnit && specificFeature.featureUnit !== null) {
      if (specificFeature.featureUnit.symbol) {
        symbolVal = specificFeature.featureUnit.symbol;
      }
    }

    return symbolVal;
  },

  specStructure: function(specificationStructureInput, specificFeature, indexFeature) {
    var specificationStructure = specificationStructureInput,
        symbolDetail = '';

    if (specificFeature.range) {
      if (indexFeature === (specificFeature.featureValues.length - 1)) {
        symbolDetail = ACC.pdp.specFeatures(specificFeature);
        specificationStructure = specificationStructure + symbolDetail;
      } else {
        specificationStructure = specificationStructure + '-';
      }
    } else {
      symbolDetail = ACC.pdp.specFeatures(specificFeature);
      specificationStructure = specificationStructure + symbolDetail;

      if (indexFeature === (specificFeature.featureValues.length - 1)) {
        specificationStructure = specificationStructure + ' ';
      } else {
        specificationStructure = specificationStructure + '<br/>';
      }
    }

    return specificationStructure;
  },

  pdpSpecs: function(productDataMap) {
    var $productClassificationMain = $('.ph-pdp_specification__main');

    if (productDataMap.classifications && (productDataMap.classifications.length !== 0)) {
      $productClassificationMain.removeClass(ACC.pdp.displayNone);

      var specificationArray = productDataMap.classifications,
          specificationStructure = '';

      $.each(specificationArray, function(index, singleSpecification) {
        if (index < 2) {
          specificationStructure = specificationStructure + '<div class="ph-productdetailpage__featureparent featureClass ph-p-0 ph-w-100 ph-pdp_spec_parent">';
        } else {
          $('.ph-productSpec_showbuttons').removeClass(ACC.pdp.displayNone);
          specificationStructure = specificationStructure + '<div class="ph-productdetailpage__featureparent ph-productdetailpage__featuretoggle ph-d-none ph-p-0 ph-w-100 ph-pdp_spec_parent">';
        }

        specificationStructure = specificationStructure + '<div class="ph-productdetailpage__featureheading ph-pdp_spec_heading ph-pl-0 ph-w-100">' + singleSpecification.name + '</div>';
        specificationStructure = specificationStructure + '<div class="ph-productdetailpage__featurewrapper">';
        $.each(singleSpecification.features, function(indexSpecific, specificFeature) {
          specificationStructure = specificationStructure + '<div class="ph-pdp_spec_box"><div class="ph-pdp_spec_head ph-productdetailpage__featuresubhead attrib">' + specificFeature.name + '</div>';
          specificationStructure = specificationStructure + '<div class="ph-productdetailpage__featuresubdetails">';
          $.each(specificFeature.featureValues, function(indexFeature, featureValues) {
            specificationStructure = specificationStructure + featureValues.value;
            specificationStructure = ACC.pdp.specStructure(specificationStructure, specificFeature, indexFeature);
          });
          specificationStructure = specificationStructure + '</div></div>';
        });

        specificationStructure = specificationStructure + ACC.pdp.closingTwoDivs;
      });
      $productClassificationMain.find('.ph-pdp_specification__detail').append(specificationStructure);
      $(document).on('click', '.ph-productdetailpage__featurebuttonall', function() {
        window.gaclkFn.gaButtonClicks({
          elementClass: '',
          triggerType: 'button',
          sectionValue: 'specifications',
          linkValue: 'show_more_specifications'
        });
      });
      $(document).on('click', '.ph-productdetailpage__featurebuttonless', function() {
        window.gaclkFn.gaButtonClicks({
          elementClass: '',
          triggerType: 'button',
          sectionValue: 'specifications',
          linkValue: 'show_less_specifications'
        });
      });
    }
  },

  pdpSuggestedProductsMain: function(relatedProductsDataMap) {
    var relatedProductAvailable = false,
        componentProductCodeArray = [];

    $('.ph-suggestedproducts__component--code').each(function(componentProductCodeIndex) {
      componentProductCodeArray[componentProductCodeIndex] = $(this).html();
    });

    $.each(relatedProductsDataMap, function(relatedProductsIndex, individualRelatedProductsData) {
      $.each(componentProductCodeArray, function(componentProductCodeIndex, individualComponentProductCode) {
        if (individualComponentProductCode === individualRelatedProductsData.code) {
          relatedProductAvailable = true;
        }
      });

      if (!relatedProductAvailable) {
        ACC.pdp.pdpSuggestedProducts(individualRelatedProductsData);
      }
    });
  },

  pdpSuggestedProducts: function(individualRelatedProductsData) {
    var suggestedProductsCardStructure = '',
        suggestedProductsImageStructure = '',
        suggestedProductsCtnStructure = '';

    var suggestedProductsUrl = ACC.pdp.pdpNullCheck(individualRelatedProductsData.url),
        suggestedProductsName = ACC.pdp.pdpNullCheck(individualRelatedProductsData.name),
        suggestedProductsDescription = ACC.pdp.pdpNullCheck(individualRelatedProductsData.description),
        suggestedProductsImageUrl = ACC.pdp.pdpNullCheck(individualRelatedProductsData.imageURL),
        suggestedProductsCode = ACC.pdp.pdpNullCheck(individualRelatedProductsData.code),
        suggestedProductsCtn = ACC.pdp.pdpNullCheck(individualRelatedProductsData.ctn);

    if (suggestedProductsImageUrl) {
      suggestedProductsImageStructure = suggestedProductsImageStructure + '<img class="ph-card-image ph-pdp_suggestedproducts__image--js" src="' +
                                        suggestedProductsImageUrl + '?wid=130&hei=130&$jpgsmall$" alt="' + suggestedProductsName + '" title="' +
                                        suggestedProductsName + '" class="thumb" />';
    } else {
      suggestedProductsImageStructure = suggestedProductsImageStructure + '<theme:image code="img.missingProductImage.lister" alt="' +
                                        suggestedProductsName + '" title="' + suggestedProductsName + '" />';
    }

    if (suggestedProductsCode === suggestedProductsCtn) {
      suggestedProductsCtnStructure = suggestedProductsCtnStructure + '<p class="ph-product-number">' + suggestedProductsCode + '</p>';
    } else {
      suggestedProductsCtnStructure = suggestedProductsCtnStructure + '<p class="ph-product-number">' + suggestedProductsCtn + '/' + suggestedProductsCode + '</p>';
    }

    suggestedProductsCardStructure = suggestedProductsCardStructure + '<li class="ph-pdp_suggestedproducts__section--js"><div class="ph-card"><a href="' +
                                     suggestedProductsUrl + '"><div class="ph-card-image-wrapper">' + suggestedProductsImageStructure +
                                     '</div><div class="ph-card-product-details">' + suggestedProductsCtnStructure + '<p class="ph-product-title">' +
                                     suggestedProductsName + '</p><p class="ph-product-content">' + suggestedProductsDescription + '</p></div></a></div></li>';

    $('.ph-suggested-products__jcarousel ul').append(suggestedProductsCardStructure);
    $('.ph-suggested-products-wrapper').removeClass('hidden');
    ACC.suggestedproducts.bindAll();
  },

  pdpNullCheck: function(productVal) {
    if (productVal) {
      return productVal;
    }

    return '';
  },

  pdpProductFeature: function(featureDataMap) {
    var featuretitletext = $('.ph-pdp-featuretitletext').html(),
        featureDataStructureTitle = '<div class="ph-productdetailpage__featuretitle ph-px-0 ph-mt-2 ph-mb-0 ph-col-12">' + featuretitletext + '</div>',
        featureDataStructure = '<div class="ph-productfeature_main ph-col-12 ph-d-flex ph-mt-1 ph-px-0">' +
                            '<div class="ph-productfeature_section_main ph-px-0 ph-pt-1 ph-row ph-col-12 ph-d-flex">',
        featureCount = 0,
        featureNoImageText = $('.ph-pdpfeature__noimagetext').html();

    $.each(featureDataMap, function(featureDataIndex, singleFeatureData) {
      var singleFeatureAllSubDetails = singleFeatureData.features;

      $.each(singleFeatureAllSubDetails, function(singleFeatureIndex, singleFeatureSubDetails) {
        if (featureCount === 0) {
          featureDataStructure = featureDataStructureTitle + featureDataStructure;
        }

        featureCount = featureCount + 1;

        if (featureCount < 4) {
          featureDataStructure = featureDataStructure + '<div class="ph-productfeature_section ph-col-12 ph-col-md-4">';
        } else {
          featureDataStructure = featureDataStructure + '<div class="ph-productfeature_section ph-productfeature_section_showmore ph-d-none ph-col-12 ph-col-md-4">';
        }

        featureDataStructure = featureDataStructure + '<div class="ph-productfeature_row_main"><div class="ph-productfeature_row">';

        if (singleFeatureSubDetails.featureImage) {
          featureDataStructure = featureDataStructure + '<div class="ph-productfeature_image_main"><p class="ph-productfeature_image ph-mb-2">' +
                                 '<img class="ph-col-12 ph-px-0" src="' + singleFeatureSubDetails.featureImage + '?wid=300&hei=200&$jpglarge$"' +
                                 'alt="' + featureNoImageText + '"/>' + ACC.pdp.closingPnDiv;
        }

        if (singleFeatureSubDetails.featureName) {
          featureDataStructure = featureDataStructure + '<div class="ph-productfeature_heading_main"><p class="ph-productfeature_heading">' + singleFeatureSubDetails.featureName +
                                 ACC.pdp.closingPnDiv;
        }

        if (singleFeatureSubDetails.featureLongDescription) {
          featureDataStructure = featureDataStructure + '<div class="ph-productfeature_shortdescription_main"><p class="ph-productfeature_shortdescription">' +
                                 singleFeatureSubDetails.featureLongDescription + ACC.pdp.closingPnDiv;
        }

        if (singleFeatureSubDetails.featureGlossary) {
          featureDataStructure = featureDataStructure + '<div class="ph-productfeature_description_main"><p class="ph-productfeature_description ph-pb-4">' +
                                 singleFeatureSubDetails.featureGlossary + ACC.pdp.closingPnDiv;
        }

        featureDataStructure = featureDataStructure + '</div></div></div>';
      });
    });

    var returnedFeatureDataStructure = ACC.pdp.pdpProductSubFeature(featureCount);

    featureDataStructure = featureDataStructure + returnedFeatureDataStructure + ACC.pdp.closingTwoDivs;

    $('.ph-pdp_productfeature--wrapper').html(featureDataStructure);
    $(document).on('click', '.ph-productfeature_showbuttons > .ph-productfeature_button_showall', function() {
      window.gaclkFn.gaButtonClicks({
        elementClass: '',
        triggerType: 'button',
        sectionValue: 'productfeature',
        linkValue: 'showall_product_features'
      });
    });
    $(document).on('click', '.ph-productfeature_showbuttons > .ph-productfeature_button_showless', function() {
      window.gaclkFn.gaButtonClicks({
        elementClass: '',
        triggerType: 'button',
        sectionValue: 'productfeature',
        linkValue: 'showless_product_features'
      });
    });
  },

  pdpProductSubFeature: function(featureCount) {
    var featureDataStructure = '',
        featureShowAllText = $('.ph-pdpfeature__showalltext').html(),
        featureShowLessText = $('.ph-pdpfeature__showlesstext').html();

    if (featureCount > 3) {
      featureDataStructure = '<div class="ph-productfeature_showbuttons ph-productdetailpage__featureshowall ph-col-12 ph-py-2 ph-mb-4">' +
                             '<div class="ph-col-12 ph-col-md-5 ph-col-lg-4 ph-productfeature_button_showall ph-loginregister">' + featureShowAllText + '</div>' +
                             '<div class="ph-col-12 ph-col-md-5 ph-col-lg-4 ph-productfeature_button_showless ph-loginregister ph-d-none">' + featureShowLessText +
                             ACC.pdp.closingTwoDivs;
    }

    return featureDataStructure;
  },
  pdpResourcesDetails: function(resourceDataMap) {
    var resourceHeading = $('.ph-pdpresources__heading').html(),
        resourceSubHeading = $('.ph-pdpresources__subheading').html(),
        resourceSvg = $('.ph-pdpresources__svg').html(),
        resourceDisplayTitle = '',
        resourcesDataStructure = '<div class="ph-resources"><div class="ph-productdetailpage__featurespecification">' + resourceHeading + '</div>' +
                                 '<h3 class="ph-col-12 ph-p-0  ph-float-left ph-productdetailpage__featureheading">' + resourceSubHeading + '</h3>' +
                                 '<ul class="ph-col-12 ph-float-left ph-p-0 ph-mb-4">';

    $.each(resourceDataMap, function(resourcesDataIndex, singleResourceData) {
      resourcesDataStructure = resourcesDataStructure + '<li class="ph-col-md-4 ph-mr-sm-0 ph-mr-md-2 ph-mt-2 ph-col-sm-12 ph-float-left ph-p-2 ' +
                               'ph-productdetailpage__resourcesbox" lang="' + singleResourceData.locale + '" data-url="' + singleResourceData.locale + '">' + resourceSvg +
                               '<span class="ph-col-10 ph-float-left">';

      if (singleResourceData.caption) {
        resourceDisplayTitle = singleResourceData.caption;
      } else if (singleResourceData.description) {
        resourceDisplayTitle = singleResourceData.description;
      } else if (singleResourceData.asset) {
        resourceDisplayTitle = singleResourceData.asset;
      }

      var singleResourceDataAsset = ACC.pdp.pdpNullCheck(singleResourceData.asset);

      resourcesDataStructure = resourcesDataStructure + '<a class="ph-productdetailpage__resourcestext ph-float-left" href="' + singleResourceDataAsset + '"' +
                               'title="' + resourceDisplayTitle + '" target="_blank">' + resourceDisplayTitle + '</a>';

      if (singleResourceData.version) {
        resourcesDataStructure = resourcesDataStructure + '<span class="ph-productdetailpage__addinfotext">' + singleResourceData.version + '</span>';
      }

      if (singleResourceData.lastModified) {
        resourcesDataStructure = resourcesDataStructure + '<span class="ph-productdetailpage__addinfotext">' + singleResourceData.lastModified + '</span>';
      }

      resourcesDataStructure = resourcesDataStructure + '</span></li>';
    });
    resourcesDataStructure = resourcesDataStructure + '</ul></div>';

    return resourcesDataStructure;
  },
  pdpResourcesDetailsNew: function(resourceDataMap, resourceHeading, resourceSubHeading) {
    var resourceSvg = $('.ph-pdpresources__svg').html(),
        resourceDisplayTitle = '',
        fileTypeName = '',
        resourceDateDisplay = '',
        resourcesDataStructure = '<div class="ph-resources"><div class="ph-productdetailpage__featurespecification">' + resourceHeading + '</div>' +
                                 '<h3 class="ph-col-12 ph-p-0 ph-productdetailpage__featureheading ph-float-left">' + resourceSubHeading + '</h3>' +
                                 '<div class="ph-downloadBannerContainer ph-col-12 ph-row ph-p-0 ph-pb-2 ">';

    $.each(resourceDataMap, function(resourcesDataIndex, singleResourceData) {
      var singleResourceDataAsset = ACC.pdp.pdpNullCheck(singleResourceData.asset);

      resourcesDataStructure = resourcesDataStructure + '<a target="_blank" href="' +
       singleResourceDataAsset + '" class="ph-downloadBannerItem ph-col-12 ph-col-md-6 ph-col-lg-4 ' +
                               '" lang="' + singleResourceData.locale + '" data-url="' + singleResourceData.locale + '">';

      if (singleResourceData.caption) {
        resourceDisplayTitle = singleResourceData.caption;
      } else if (singleResourceData.description) {
        resourceDisplayTitle = singleResourceData.description;
      } else if (singleResourceData.asset) {
        resourceDisplayTitle = singleResourceData.asset;
      }

      if (singleResourceData.extension) {
        fileTypeName = singleResourceData.extension;
      } else if (singleResourceData.asset) {
        fileTypeName = singleResourceData.asset;
      }

      if (fileTypeName) {
        fileTypeName = fileTypeName.toUpperCase() + ' ' + $.trim($('.ph-pdpresources__filelabel').html());
      }

      if (fileTypeName && singleResourceData.displayExtent) {
        fileTypeName = fileTypeName + ', ' + singleResourceData.displayExtent;
      }

      if (singleResourceData.lastModified) {
        var pdpresourcesDateformat = $('.ph-atpDateFormat').html();

        resourceDateDisplay = ACC.pdp.formatDate(new Date(Date.parse(singleResourceData.lastModified)), pdpresourcesDateformat);
      }

      resourcesDataStructure = resourcesDataStructure +
       '<div class="ph-downloadBannerInsideItems"><div class=" ph-downloadBanner_imageDiv">' + resourceSvg + '</div>';

      resourcesDataStructure = resourcesDataStructure + '<div class="ph-downloadBannerTextSection"><div class="ph-downloadBannerText_title" title="' +
       resourceDisplayTitle + '">' + resourceDisplayTitle + '</div>' +
      '<div class="ph-downloadBannerText_desc">' + fileTypeName + '</div>' +
      '<div class="ph-downloadBannerText_date">' + resourceDateDisplay + '</div></div></div>';

      resourcesDataStructure = resourcesDataStructure + '</a>';
    });
    resourcesDataStructure = resourcesDataStructure + ACC.pdp.closingTwoDivs;

    return resourcesDataStructure;
  },
  pdpResources: function(resourceDataMap) {
    var resourceHeading = $('.ph-pdpresources__heading').html(),
        resourceSubHeading = $('.ph-pdpresources__subheading').html();
    var resourcesDataStructure = ACC.pdp.pdpResourcesDetailsNew(resourceDataMap, resourceHeading, resourceSubHeading);

    $('.ph-pdp_productresources--wrapper').html(resourcesDataStructure);
    $(document).on('click', '.ph-productdetailpage__resourcestext', function() {
      if ($(this).attr('href')) {
        var resourceText = 'resource';

        if ($(this).text()) {
          resourceText = $.trim($(this).text()).replace(/ /g, '_');
        }

        window.gaclkFn.gaButtonClicks({
          elementClass: '',
          triggerType: 'click',
          sectionValue: 'product_resources',
          linkValue: resourceText
        });
      }
    });
  },
  pdpCaseStudiesNew: function(caseStudiesDataMap) {
    var caseStudiesDataStructure = ACC.pdp.pdpResourcesDetailsNew(caseStudiesDataMap, '', $('.ph-pdpcasestudies__heading').html());

    $('.ph-pdp_productcasestudies--wrapper').html(caseStudiesDataStructure);
  },
  pdpCaseStudies: function(caseStudiesDataMap) {
    var caseStudiesHeading = $('.ph-pdpcasestudies__heading').html(),
        caseStudiesDataStructure = '<div class="ph-casestudies-section">' +
                                   '<h3 class="ph-col-12 ph-p-0 ph-productdetailpage__featureheading ph-float-left">' + caseStudiesHeading + '</h3>' +
                                   '<ul class="ph-col-12 ph-float-left ph-p-0 ph-mt-2">';

    $.each(caseStudiesDataMap, function(caseStudiesIndex, singleCaseStudyData) {
      var singleCaseStudyDataLocale = ACC.pdp.pdpNullCheck(singleCaseStudyData.locale),
          singleCaseStudyDataAsset = ACC.pdp.pdpNullCheck(singleCaseStudyData.asset),
          singleCaseStudyDataCaption = ACC.pdp.pdpNullCheck(singleCaseStudyData.caption);

      caseStudiesDataStructure = caseStudiesDataStructure + '<li class="ph-col-12 ph-p-0 ph-productdetail__casestudy" lang="' + singleCaseStudyDataLocale + '"' +
                                 ' data-url="' + singleCaseStudyDataLocale + '"><span><a class="ph-productdetailpage__resourcestext ph-icon-arrow-right"' +
                                 ' href="' + singleCaseStudyDataAsset + '" target="_blank">' + singleCaseStudyDataCaption + '</a></span></li>';
    });

    caseStudiesDataStructure = caseStudiesDataStructure + '</ul></div>';

    $('.ph-pdp_productcasestudies--wrapper').html(caseStudiesDataStructure);
  },
  pdpVariantCall: function(productDataMap) {
    var productClustercode = productDataMap.clusterCode,
        productSalesOrg = productDataMap.salesOrg,
        productid = productDataMap.code;

    $.ajax({
      url: ACC.config.contextPath + '/lazyload/getProductClusters.json',
      type: 'GET',
      data: {
        clusterCode: productClustercode,
        salesOrg: productSalesOrg
      },
      async: false,
      cache: true,
      headers: {
        'Cache-Control': ACC.pdp.maxAgeValue
      },
      dataType: 'json',
      success: function(result) {
        if (result.clusterProductsData) {
          ACC.pdp.variantOptions(result.clusterProductsData, productid);
        }
      }
    });
  },
  variantOptions: function(variants, productCode) {
    var variantStr = $('.ph-pdpmain').hasClass('.ph-withimagediv');

    if (variantStr === true) {
      $('.ph-pdp_variant-section').addClass('ph-col-12');
    }

    var pageproductCode = productCode,
        clusterDataStructure = '<fieldset> <legend class="ph-d-none"></legend>' +
       '<div class="form_field-input ph-pdp_variant-section ph-form__fieldwrap ph-icon-arrow-down ph-px-0 ">' +
       '<select id="veriants" labelKey="veriants" path="veriants" name="veriants" mandatory="false" class="ph-label__thirty  ph-checkInputValue  ph-forminput ph-m-0">',
        variantClusterName = '';

    $.each(variants, function(caseStudiesIndex, variant) {
      variantClusterName = ACC.pdp.pdpNullCheck(variant.clusterName);

      var variantclusterValue = ACC.pdp.pdpNullCheck(variant.clusterValue),
          variantproductCode = ACC.pdp.pdpNullCheck(variant.productCode);

      if (pageproductCode === variantproductCode) {
        clusterDataStructure = clusterDataStructure + '<option selected="selected" value="' + variantproductCode + '" >' + variantclusterValue + '</option>';
      } else {
        clusterDataStructure = clusterDataStructure + '<option value="' + variantproductCode + '" >' + variantclusterValue + '</option>';
      }
    });

    clusterDataStructure = clusterDataStructure + '</select>' +
      '<label class="ph-formlabel ph-p-0">' + variantClusterName + '</label></div></fieldset>';

    $('.ph-pdp_variant--wrapper').html(clusterDataStructure);
  },
  pdpAssetsCall: function(productCode) {
    $.ajax({
      url: ACC.config.contextPath + '/lazyload/getPRXAssetsForProduct.json',
      type: 'GET',
      data: {
        productCode: productCode
      },
      async: false,
      cache: true,
      headers: {
        'Cache-Control': ACC.pdp.maxAgeValue
      },
      dataType: 'json',
      success: function(result) {
        var $productAssetandRightStructure = '';

        if (result.imageAssets.length >= 1 || result.videoAssets.length >= 1) {
          var assetObj = ACC.pdp.pdpcarosalAssets(result, productCode);

          $productAssetandRightStructure = $productAssetandRightStructure + '<div class="ph-col-12 ph-col-lg-6 ph-col-xl-7 ph-float-left ph-p-0 ph-asset-section"> ' +
          assetObj.$productAssetStructure +
          assetObj.$productdowncarouselAssetStructure +
          '</div><div class="ph-pdp_description_rightsection ph-col-12 ph-col-lg-6 ph-col-xl-5 ph-float-left last ph-productpricecontainer ph-pdpmain ph-withimagediv ph-p-0">';
        } else {
          $productAssetandRightStructure = $productAssetandRightStructure + '<div class="ph-col-12 ph-col-lg-9 ph-float-left last ph-productpricecontainer ph-pdpmain ph-px-0">';
        }

        $('.ph-asset-wrapper').append($productAssetandRightStructure);
      }
    });
  },

  /* eslint-disable max-statements */

  pdpcarosalAssets: function(pdpAssets, productCode) {
    var imageZoomLinkText = $('.accessibilityTransImgZoomLink').text(),
        prodIconExpandText = $('.accessibilityTransProdIconExpand').text(),
        $productAssetStructure = '<div class="ph-col-12 ph-float-left ph-imgsiz ph-pdp-Image ph-p-0">' +
    '<div class="ph-prod_image_main" id="primary_image" data-currentimage="1">' +
    '<a class="imageZoomLink  ph-productImg" id="ph-imageLink" href="javascript:void(0);" title="" aria-label="' + imageZoomLinkText + '">' +
    '<div class="ph-product__stage ph-product__imageshow">' +
    '<div class="ph-product__carousel ph-product__carouselStage" id="ph-product__carousel"><ul>';

    if (pdpAssets.imageAssets) {
      var imageAssets = pdpAssets.imageAssets;

      $.each(imageAssets, function(caseIndex, image) {
        $productAssetStructure = $productAssetStructure + '<li class="ph-pdpzoom">' +
          '<img src = "' + image.asset + '?wid=300&hei=300&$jpglarge$" data-primaryimagesrc="' + image.asset +
          '" data-galleryposition ="' + caseIndex + '" alt="Enlarged view of picture" title="" data-zoom-image ="' + image.asset +
          '?wid=1000&hei=1000&$jpglarge$" class="ph-imageScreen"/>' +
          '<span class="ph-expandimg ph-d-none ph-d-md-block">' +
          '<img src="/_ui/desktop/common/philipsUI/src/images/product-icon-expand.svg" aria-label="' + prodIconExpandText + '"/></span></li>';
      });
    }

    if (pdpAssets.videoAssets) {
      var videosAssets = pdpAssets.videoAssets;

      $.each(videosAssets, function(caseStudiesIndex, videoAsset) {
        $productAssetStructure = $productAssetStructure + '<li class="ph-video"><div class="ph-video-overlay"><video class="ph-product__videoplay">' +
                    'poster="' + videoAsset.asset + '?hei=300&$jpglarge$"' +
                    'data-primaryimagesrc="' + videoAsset.asset + '"' +
                    'data-galleryposition="' + caseStudiesIndex + '"' +
                    'alt="' + videoAsset.caption + '"' +
                    'title="' + videoAsset.caption + '"' +
                    'data-asset="' + videoAsset.asset + '">' +
                    '<source src="' + videoAsset.asset + '" type="video/mp4" />' +
                    '</video>' +
                    '<div class="ph-col-12 ph-video__icons"><div class="ph-video-desc" style="display:none">' + videoAsset.description + '</div>' +
                    '<div class="ph-video-icons-section"><div class="ph-col-9 ph-float-left ph-p-0"><div class="ph-video__playtimeslot ph-p-0 ph-col-4">' +
                    '<div class="ph-product__playIconDetailImage ph-icon-play-button ph-float-left"></div><div class="ph-video__time ph-float-left">' +
                    '<span class="ph-video__currenttime"></span></div></div><div class="ph-video__progressslot ph-p-0 ph-col-8">' +
                    '<div class="ph-video__progress"><span class="ph-video__bufferbar"></span><span class="ph-video__timebar">' +
                    '<span class="ph-video__circle"></span></span></div></div></div><div class="ph-col-3 ph-float-left ph-p-0 ph-video__volumefscontrols">' +
                    '<div class="ph-icon-volume-medium ph-video__sound ph-video__sound2 ph-float-left ph-col-6 ph-p-0"></div>' +
                    '<div class="ph-video__volume ph-col-4"><span class="ph-video__volumebar"><span class="ph-video__circle"></span></span></div>' +
                    '<div class="ph-video__enlarge ph-col-2"><span class="ph-icon-fullscreen ph-switchscreen"></span></div>' +
                    '</div></div></div></div></li>';
      });
    }

    $productAssetStructure = $productAssetStructure + '</ul></div><span class="ph-prev-stage ph-icon-arrow-left ph-d-none"></span>' +
      '<span class="ph-next-stage ph-icon-arrow-right ph-d-none"></span></div>';

    if (pdpAssets.imageAssets || pdpAssets.videoAssets) {
      $productAssetStructure = $productAssetStructure + '<p class="jcarousel-pagination ph-jcarousel_pagination ph-d-none"></p>';
    }

    $productAssetStructure = $productAssetStructure + '</a>' +
     '<div class="ph-pdp_extraloader hidden">' +
     '<div class="hide-video-loader"><img src="/_ui/desktop/common/philipsUI/src/images/spinner.gif" alt="" width="32px" height="32px" /></div>' +
     '<div class="ph-loading-panel"></div>' +
     '<div id="s7_spinview" class="thumb s7spinviewer">' +
    '<section data-comp-id="p18v2PexArea"  class="p-p18v2-pex-area p-viewer360-pex-area  p-loaded-360"></section>' +
    '<div class="p-inner-wrapper">' +
    '<div class="p-top-wrapper">' +
    '<ul class="p-viewer"><li class="p-packshot-item p-current" data-type="packshot" data-pex-id="p-packshot"><div class="p-packshot">' +
    '<div class="p-picture-wrapper" itemprop="image"><span data-image-share="false" class="p-picture p-normal-view">' +
    '<img alt="" src=""></span><div data-popup-close-btn-s-xs="Back to Page" data-img="" data-hotspot="" data-360-close-text="Close" data-parent-class=".p-p18v2-pex-area"' +
    'data-parent-instance="p18PexArea" data-360-loading-text="Waiting for server..." class="p-360-viewer p-360-holder"></div>' +
    '<div class="p-packshot-options"><span class="p-reset-button p-icon-360-rotate"></span>' +
    '<a class="p-360 p-show-360" data-track-description="image_overlay:3d_view" data-track-name="interaction" data-track-type="track-conversion" href="#">' +
    '<span class="p-icon-360-reset">360&deg;</span></a></div></li></ul></div></div></section></div>' +
    '<div class="spinner-text"><span>360&deg;</span><img src="/_ui/desktop/common/philipsUI/src/images/rotation.png" alt="" width="25" height="25" /></div>' +
    '</div></div>' +
    '<div class="zoom_lightbox"></div></div>';

    var $productdowncarouselAssetStructure = '';

    if (pdpAssets.imageAssets.length > 1 || pdpAssets.videoAssets.length > 1) {
      $productdowncarouselAssetStructure = '<div class="ph-col-7 ph-p-0 ph-d-block ph-downcarouselimage">' +
      '<div class="ph-product__navigation ph-mb-1 ph-ml-2 ph-float-left ph-product__imageCarousel " id="ph-product__imageCarousel">' +
      '<span class="ph-prev-navigation ph-icon-arrow-left"></span><span class="ph-next-navigation ph-icon-arrow-right"></span>' +
      '<div class="ph-product__carousel ph-product__carouselNavigation"><ul>';

      if (pdpAssets.imageAssets) {
        var carosalImages = pdpAssets.imageAssets;

        $.each(carosalImages, function(caseIndex, image) {
          $productdowncarouselAssetStructure = $productdowncarouselAssetStructure + '<li>' +
            '<img src = "' + image.asset + '?wid=65&hei=65&$jpglarge$" data-primaryimagesrc="' + image.asset +
            '" data-galleryposition ="' + caseIndex + '" alt="' + productCode + '" title="' + productCode +
            '" data-zoom-image ="' + image.asset + '?wid=1000&hei=1000&$jpglarge$" class="ph-imageScreen"/>' +
            '</li>';
        });
      }

      if (pdpAssets.videoAssets) {
        var carosalVideos = pdpAssets.videoAssets;

        $.each(carosalVideos, function(caseStudiesIndex, videoAsset) {
          var url = videoAsset.asset,
              videoUrl = url.replace('content', 'image'),
              dataAsset = url.replace('//images.philips.com/is/content/', '');

          $productdowncarouselAssetStructure = $productdowncarouselAssetStructure + '<li><img src="' + videoUrl + '?wid=68&hei=68&$jpglarge$" data-primaryimagesrc="' + videoUrl +
                      'data-galleryposition="' + caseStudiesIndex + '" ' +
                      'alt="' + videoAsset.caption + '" ' +
                      'title="' + videoAsset.caption + '" ' +
                      'data-asset="' + dataAsset + '"/>' +
                      '<div class="ph-product__playIcon"><img src="/_ui/desktop/common/philipsUI/src/images/product-icon-play.svg" alt="' + videoAsset.caption + '"' +
                      'title="' + videoAsset.caption + '" /></li>';
        });
        $productdowncarouselAssetStructure = $productdowncarouselAssetStructure + '</ul></div></div></div>';
      }
    }

    return {
      $productAssetStructure: $productAssetStructure,
      $productdowncarouselAssetStructure: $productdowncarouselAssetStructure
    };
  },

  /* eslint-enable max-statements */

  pdpPageContentCall: function(productid, variantStatus, suggestedProductStatus) {
    ACC.pdp.pdpFeature();
    ACC.pdp.pdpAjaxCall(productid, variantStatus, suggestedProductStatus);
    ACC.pdp.pdpFeatureAjaxCall(productid);
    ACC.pdp.pdpResourceAjaxCall(productid);
  },
  pdpGetProductCode: function() {
    var productCode = '',
        $productCodeVal = '',
        $productCtnVal = '';

    $productCodeVal = $(ACC.pdp.productMain).find('.ph-pdp__productcode').html();
    $productCtnVal = $(ACC.pdp.productMain).find('.ph-pdp__productctn').html();

    if ($productCodeVal) {
      productCode = $productCodeVal;
    } else if ($productCtnVal) {
      productCode = $productCtnVal;
    }

    return productCode;
  },
  changeShareFeature: function(productData) {
    var hostName = window.location.origin,
        pageUrl = hostName + productData.url,
        shareLabelText = $('.accessibilityShareLink').text(),
        $productShareStructure = '<a class="ph-shareicon-image ph-js ph-mr-1 ph-share" aria-label="' + shareLabelText + '" href="mailto: ?subject=Information (' +
    productData.name + ')&body=You might like this page: ' + productData.name + ' ' + pageUrl + '"></a>';

    $('.ph-mediadiv').append($productShareStructure);
  },
  setAttributeNewProductId: function(productid, el) {
    var idAttr = $(el).attr('id');
    var indexoflastDash = idAttr.lastIndexOf('-');

    idAttr = idAttr.substr(0, indexoflastDash);

    var newidAttr = idAttr + '-' + productid;

    $(el).attr('id', newidAttr);
  },
  onChangeWishList: function(productid) {
    var dataAttr = 'data-productcode';

    $('.ph-prod-addtoshoppinglist').attr(dataAttr, productid);
    ACC.pdp.setAttributeNewProductId(productid, $('.ph-addtoshoppinglist-container'));
    $('.ph-addtoshoppinglist').attr(dataAttr, productid);
    $('.ph-savetolistBtn').attr(dataAttr, productid);
    $('.ph-addtoshoppinglist li input').each(function() {
      ACC.pdp.setAttributeNewProductId(productid, this);
    });
  },
  pdpPrxCtn: function(productDataMap) {
    var pdpProductCtn = '.ph-pdp_product_ctn',
        $productCtn = $(ACC.pdp.productMain).find(pdpProductCtn);

    $(ACC.pdp.productMain).find(pdpProductCtn).attr('data-productid', productDataMap.ctn);

    if (productDataMap.ctn && productDataMap.code !== null && productDataMap.ctn !== productDataMap.code) {
      $productCtn.html(productDataMap.ctn + '/' + productDataMap.code);
    } else if (productDataMap.code) {
      $productCtn.html(productDataMap.code);
    } else if (productDataMap.ctn) {
      $productCtn.html(productDataMap.ctn);
    }
  },
  formatDate: function(date, patternStr) {
    var datePatternStr = patternStr;

    if (!datePatternStr) {
      datePatternStr = 'MMMM dd, YYYY';
    }

    var monthNames = [
      $.trim($('.ph-january').html()),
      $.trim($('.ph-february').html()),
      $.trim($('.ph-march').html()),
      $.trim($('.ph-april').html()),
      $.trim($('.ph-may').html()),
      $.trim($('.ph-june').html()),
      $.trim($('.ph-july').html()),
      $.trim($('.ph-august').html()),
      $.trim($('.ph-september').html()),
      $.trim($('.ph-october').html()),
      $.trim($('.ph-november').html()),
      $.trim($('.ph-december').html())
    ];
    var dayOfWeekNames = [
      $.trim($('.ph-sunday').html()),
      $.trim($('.ph-monday').html()),
      $.trim($('.ph-tuesday').html()),
      $.trim($('.ph-wednesday').html()),
      $.trim($('.ph-thursday').html()),
      $.trim($('.ph-friday').html()),
      $.trim($('.ph-saturday').html())
    ];
    var day = date.getDate(),
        month = date.getMonth(),
        year = date.getFullYear(),
        hour = date.getHours(),
        minute = date.getMinutes(),
        second = date.getSeconds(),
        miliseconds = date.getMilliseconds(),
        h = hour % 12,
        hh = ACC.pdp.twoDigitPad(h),
        hhNew = ACC.pdp.twoDigitPad(hour),
        mm = ACC.pdp.twoDigitPad(minute),
        ss = ACC.pdp.twoDigitPad(second),
        aaa = 'PM',
        eeee = dayOfWeekNames[date.getDay()],
        eee = eeee.substr(0, 3),
        dd = ACC.pdp.twoDigitPad(day),
        m = month + 1,
        mmNew = ACC.pdp.twoDigitPad(m),
        mmmm = monthNames[month],
        mmm = mmmm.substr(0, 3),
        yyyy = String(year),
        yy = yyyy.substr(2, 2);

    if (hour < 12) {
      aaa = 'AM';
    }

    datePatternStr = datePatternStr
      .replace('hh', hh).replace('h', h)
      .replace('HH', hhNew).replace('H', hour)
      .replace('mm', mm).replace('m', minute)
      .replace('ss', ss).replace('s', second)
      .replace('S', miliseconds)
      .replace('dd', dd).replace('d', day)

      .replace('EEEE', eeee).replace('EEE', eee)
      .replace('yyyy', yyyy)
      .replace('YYYY', yyyy)
      .replace('yy', yy)
      .replace('YY', yy)
      .replace('aaa', aaa);

    if (datePatternStr.indexOf('MMM') > -1) {
      datePatternStr = datePatternStr
        .replace('MMMM', mmmm)
        .replace('MMM', mmm);
    } else if (datePatternStr.indexOf('mmm') > -1) {
      datePatternStr = datePatternStr
        .replace('mmmm', mmmm)
        .replace('mmm', mmm);
    } else {
      datePatternStr = datePatternStr
        .replace('MM', mmNew)
        .replace('M', m);
    }

    return datePatternStr;
  },
  twoDigitPad: function(num) {
    if (num < 10) {
      return '0' + num;
    }

    return num;
  },
  reOrderVideoAssets: function() {
    var ulNodeMain = document.querySelector('.ph-asset-wrapper .ph-product__carouselStage ul');
    var videoItemsMain = document.querySelectorAll('.ph-asset-wrapper .ph-product__carouselStage .ph-video ');

    if ($('.ph-product__carousel .placeChanged').length > 0) {
      for (var occurance = 0; occurance < $('.ph-product__carousel .placeChanged').length; occurance = occurance + 1) {
        var videoItemsNodeMain = videoItemsMain[occurance];

        if (occurance === 0) {
          ulNodeMain.insertBefore(videoItemsNodeMain, ulNodeMain.children[1]);
        }

        if (occurance === 1) {
          ulNodeMain.insertBefore(videoItemsNodeMain, ulNodeMain.children[4]);
        }
      }
    }
  },
  igtdMessageDisplay: function(productCode) {
    if ($('.igtdProduct' + productCode).length > 0) {
      $('.igtdProduct' + productCode).removeClass('hidden');
    }
  }
};

$(document).ready(function() {
  if ($('.ph-page-productDetails').length > 0) {
    var productid = ACC.pdp.pdpGetProductCode(),
        variantStatus = 'true',
        suggestedProductStatus = false;

    ACC.decisionPageInfiniteLoader.sparepartRibbonCheck($('#productDetailUpdateable'));
    ACC.pdp.pdpPageContentCall(productid, variantStatus, suggestedProductStatus);
    /* eslint-disable max-statements */
    $(document).on('change', '#veriants', function() {
      productid = $(this).val();

      variantStatus = 'false';
      suggestedProductStatus = true;

      $(ACC.pdp.productMain).find('.ph-pdp_product_ctn').empty();
      $(ACC.pdp.productMain).find('.ph-pdpproduct-code').attr('value', productid);
      $(ACC.pdp.productMain).find('.ph-pdp-button').remove();
      $(ACC.pdp.productMain).find('.ph-pdp_strike_finalprice,.ph-pdp_strike_price').empty();
      $('#prod_tabs').find('.ph-productfeature_main,.ph-productdetailpage__featureparent').remove();
      $('#productDetailUpdateable').find('.ph-pdp-Image, .ph-downcarouselimage').remove();
      $('.prod_content').find('.ph-resources,.ph-casestudies-section').remove();
      $('.ph-suggestedproducts__component--code').empty();
      $('.ph-middleContent .ph-mediadiv').find('.ph-share').remove();
      $('.ph-middleContent .ph-suggested-products-wrapper').find('li').remove();
      $('.ph-middleContent').find('.ph-suggested-products-wrapper').addClass('hidden');
      ACC.pdp.pdpPageContentCall(productid, variantStatus, suggestedProductStatus);
      ACC.pdppricelazyload.bindAll();
      ACC.pdp.pdpAssetsCall(productid);
      ACC.product.bindAll();
      ACC.product.domreadtFirstfunctions();
      ACC.product.domreadtSecondfunctions();
      ACC.product.domreadtthirdfunctions();
      ACC.pdp.onChangeWishList(productid);
    });
    /* eslint-enable max-statements */
  }

  $(document).on('click', '.ph-suggested-products a', function() {
    window.gaclkFn.gaButtonClicks({
      elementClass: '',
      triggerType: 'click',
      sectionValue: 'suggested_products',
      linkValue: 'product' + $.trim($(this).find('.ph-product-number').html())
    });
  });
  $(document).on('click', '.ph-recentlyviewed-products a', function() {
    window.gaclkFn.gaButtonClicks({
      elementClass: '',
      triggerType: 'click',
      sectionValue: 'recently_viewed',
      linkValue: 'product' + $.trim($(this).parent().attr('data-ctn'))
    });
  });

  if (document.querySelectorAll('.ph-page-productDetails').length > 0) {
    ACC.pdp.reOrderVideoAssets();
    ACC.product.productCarousalImage();
    ACC.product.carouselVideo();
  }
});
